import { NavLink } from 'react-router-dom';
import { Icon } from './Icons';

export function BottomNav() {
  const items = [
    { to: '/', label: 'Home', Icon: Icon.Home, end: true },
    { to: '/earnings', label: 'Earnings', Icon: Icon.Money, end: false },
    { to: '/subscribers', label: 'Subs', Icon: Icon.Users, end: false },
    { to: '/settings', label: 'Settings', Icon: Icon.Settings, end: false },
  ];
  return (
    <nav
      className="snapmon-bottomnav"
      style={{
        display: 'none',
        borderTop: '1px solid var(--line)',
        background: 'var(--bg-elev)',
        padding: '6px 6px calc(6px + env(safe-area-inset-bottom))',
        gap: 4,
        position: 'sticky',
        bottom: 0,
      }}
    >
      {items.map(({ to, label, Icon: I, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          style={({ isActive }) => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            padding: '8px 6px',
            color: isActive ? 'var(--brand)' : 'var(--ink-3)',
            fontSize: 11,
            fontWeight: 500,
            textDecoration: 'none',
          })}
        >
          <I />
          {label}
        </NavLink>
      ))}
    </nav>
  );
}
